import { put, call } from 'redux-saga/effects';

import { forgotPassword } from '@api/user';
import { toastError } from '@store/notifications';

export const forgotPasswordSaga = function* ({ payload }) {
  try {
    yield call(forgotPassword, payload.data.email);
    yield call(payload.onSuccess);
  } catch (error) {
    const { fieldErrors, nonFieldErrors, hasNonFieldError, hasFieldError } = error.data || {};

    if (hasFieldError) {
      yield call(payload.setErrors, fieldErrors);
    }

    yield put(
      toastError({
        message: hasNonFieldError
          ? nonFieldErrors
          : {
              defaultMessage: 'Password reset request failed.',
              id: 'components.forgot-password-form.response.failure',
            },
      })
    );

    yield call(payload.setSubmitting, false);
  }
};
